import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Box, Button, ButtonGroup, Typography, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@mui/material";

const ControlledPreparednessRating = () => {
    const { control } = useFormContext();

    const preparednessOptions = [
        { value: 1, label: "Yes, strongly agree" },
        { value: 2, label: "Yes, agree" },
        { value: 3, label: "neutral" },
        { value: 4, label: "No, disagree" },
        { value: 5, label: "No, strongly disagree" },
    ];

    return (
        <Controller
            control={control}
            name="preparedness_rating"
            render={({ field }) => (
                <FormControl component="fieldset" sx={{ width: "100%" }}>
                    <FormLabel component="legend" sx={{ mb: 2, fontWeight: "bold" }}>
                        Do you feel more prepared to handle a real patient with this condition or situation?
                    </FormLabel>
                    <RadioGroup
                        value={field.value || ""}
                        onChange={(e) => field.onChange(parseInt(e.target.value))}
                        sx={{ gap: 1 }}
                    >
                        {preparednessOptions.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={<Radio />}
                                label={option.label}
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "1rem",
                                    },
                                }}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            )}
        />
    );
};

export default ControlledPreparednessRating; 